class modalCancelSuccessCtrl {
    constructor($scope, $uibModalInstance, items2, httpRequest, logger, modalSelConDetailService) {
        $scope.reqArrLen = items2.reqArrLen
        $scope.activeTab = items2.activeTab
        $scope.invType = items2.invType
        if ($scope.invType === 'normal') {
            $scope.totalAmt = (Math.round(items2.totalAmt * 100) / 100).toFixed(2)
        }
        $scope.totalTaxamt = (Math.round(items2.totalTaxamt * 100) / 100).toFixed(2)
        $scope.effectiveTaxamt = (Math.round(items2.effectiveTaxamt * 100) / 100).toFixed(2)
        $scope.cancel = () => {
            // $uibModalInstance.dismiss();
            $uibModalInstance.close()
        }
        const inputDeviceType = (localStorage.inputDeviceType && JSON.parse(localStorage.getItem('inputDeviceType'))) || {}
        $scope.ok = () => {
            const opening = window.layer.msg('正在处理，请您耐心等待···', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest.get_getIsCheckOrNotOperate(items2.periodCode).then(res => {
                if (res.data.value) {
                    httpRequest.post_qryIvatConfig().then((res) => {
                        // console.log(reqStr);
                        // 单机版
                        if (res.data.value.diskType == 1) {
                            const singleResObj = {
                                TAXNO: res.data.value.creditCode,
                                PASS: res.data.value.diskPassword,
                                ptPassword: res.data.value.platformPassword,
                                DATA: items2.reqStr,
                                VERSION: '',
                                TaxType: items2.checkType == 1 ? 1 : '',
                                applyType: items2.applyType, // 空-抵扣勾选 0-不抵扣勾选
                                deviceType: inputDeviceType.deviceType
                            }
                            const singleResJson = JSON.stringify(singleResObj)
                            // console.log(modalSelConDetailService);
                            const b = modalSelConDetailService.Base64()
                            const singleReqBase64 = b.encode(singleResJson)
                            $.ajax({
                                url: res.data.value.serverAddress,
                                type: 'POST',
                                data: {
                                    SID: 440302,
                                    SIDParam: singleReqBase64,
                                },
                                dataType: 'jsonp',
                                timeout: 60000,
                                success(res) {
                                    res = JSON.stringify(res)
                                    const CheckParamDTO = {
                                        checkFlag: $scope.activeTab,
                                        checked: items2.checked,
                                        u72Response: res,
                                        periodCode: items2.periodCode,
                                        // ids: items2.idArr,
                                        checkType: items2.checkType,
                                        checkInvoices: items2.checkInvoices,
                                        isCustomsPayment: items2.invType === 'normal' ? '0' : '1',
                                    }
                                    httpRequest.post_updateCheckStatusLocal(CheckParamDTO).then((res) => {
                                        window.layer.close(opening)
                                        $scope.pageChanged()
                                        // 勾选弹窗
                                        if (!res.data.success) {
                                            logger.logError(res.data.msgCode)
                                        }
                                        logger.logSuccess('提交成功')
                                    }, () => {
                                        window.layer.close(opening)
                                        $scope.pageChanged()
                                    })
                                },
                                error(XMLHttpRequest, textStatus, errorThrown) {
                                    window.layer.close(opening)
                                    $scope.pageChanged()
                                    logger.logError('u72请求错误')
                                },
                            })
                        } else {
                            const CheckParamDTO = {
                                checkFlag: $scope.activeTab,
                                checked: items2.checked,
                                periodCode: items2.periodCode,
                                // ids: items2.idArr,
                                checkType: items2.checkType,
                                checkInvoices: items2.checkInvoices,
                                deviceType: inputDeviceType.deviceType,
                                isCustomsPayment: items2.invType === 'normal' ? '0' : '1',
                            }
                            httpRequest.post_updateCheckStatusServer(CheckParamDTO).then((res) => {
                                window.layer.close(opening)
                                $scope.pageChanged()
                                if (!res.data.success) {
                                    logger.logError(res.data.msgCode)
                                }
                                logger.logSuccess('提交成功')
                            }, () => {
                                window.layer.close(opening)
                                $scope.pageChanged()
                            })
                        }
                    }, () => {
                        $scope.pageChanged()
                    })
                } else {
                    logger.logError('已申请统计或确认签名。不能取消勾选，请先撤销统计或撤销签名')
                }
            })

            $uibModalInstance.close()
        }
    }
}

modalCancelSuccessCtrl.$inject = ['$scope', '$uibModalInstance', 'items2', 'httpRequest', 'logger', 'modalSelConDetailService']
export default modalCancelSuccessCtrl


// WEBPACK FOOTER //
// ./src/components/deductionCheck/modalCancelSuccessCtrl.js